import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { sessionService } from 'redux-react-session';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import RiseLogo from 'assets/images/icons/riseLogo.svg';
import {
  BASEROUTE,
  ROUTE_LOGOUT,
  ROUTE_INITIATIVES,
  ROUTE_SIGNUP,
  ROUTE_FORGET_PASSWORD,
} from '../../../constants/urls';
import Linkedin from '../../../assets/images/linkedin.svg';
import { LoginWrapper, InitialWrapper, ButtonLogin } from './styles';
import './styles.css';


class Login extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    literals: PropTypes.object.isRequired,
    loginError: PropTypes.string.isRequired,
    doLogin: PropTypes.func.isRequired,
    app: PropTypes.object.isRequired,
    setAutoNavigation: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      showPassword: false,
      formValid: false,
      initial: true,
    };
  }

  componentDidMount() {
    const { setAutoNavigation } = this.props;
    setAutoNavigation(true);
  }

  
  handleChange = name => (event) => {
    this.setState({
      [name]: event.target.value,
    }, this.validateForm);
  };

  
  validateForm = () => {
    const {
      email,
      password,
    } = this.state;

    return this.setState({
      formValid: (email !== '' && password !== ''),
    });
  };

  
  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  login = () => {
    const { formValid, email, password } = this.state;
    const { doLogin } = this.props;
    if (formValid) {
      doLogin(email, password);
    }
  }

  handleGoLogin = () => {
    this.setState({
      initial: false,
    });
  }

  handleRegister = () => {
    this.setState({
      initial: false,
    });
  }

  openLinkedin = () => {
    const origin = window.location.origin;
    const redirectURL = `${origin}/social_oauth/linkedin`;
    const url = `${origin}/system/security/external/oauth.php?oa_ref=3c90c80eb1c2b395af81dd463425731545396064&oa_redirect=${encodeURIComponent(redirectURL)}&oa_domain=${origin}`;
    window.location.href = url;
  }

  redirectAfterLogin = () => {
    const { location } = this.props;
    if (window.urlToRedirect) {
      const { urlToRedirect } = window;
      delete window.urlToRedirect;
      window.location.href = urlToRedirect;

      return null;
    }

    return (
      <Redirect to={{
        pathname: ROUTE_INITIATIVES,
        state: location.state,
      }}
      />
    );
  }

  render() {
    const {
      literals,
      location,
      loginError,
      app,
    } = this.props;

    const {
      email,
      showPassword,
      password,
      initial,
    } = this.state;

    if (app.isAuthenticated) {
      const flagRedirect = location.state
        && location.state.from !== BASEROUTE
        && location.state.from !== ROUTE_LOGOUT;
      const redirectTo = (flagRedirect) ? location.state.from : ROUTE_INITIATIVES;
      sessionService.loadUser()
        .then(() => this.redirectAfterLogin())
        .catch(() => { });
      return (
        <Redirect to={{
          pathname: redirectTo,
          state: location.state,
        }}
        />
      );
    }

    if (initial) {
      return (
        <InitialWrapper app={app}>
          <img src={RiseLogo} alt='' />
          <p>{literals.titleText}</p>
          <p>{literals.footerText}</p>
          <button onClick={this.handleGoLogin}>{literals.loginAccount}</button>
          <Link to={ROUTE_SIGNUP} onClick={this.handleRegister}>
            <button>{literals.registry}</button>
          </Link>
        </InitialWrapper>
      );
    }

    return (
      <LoginWrapper className='Login' app={app}>
        <Grid container spacing={0} className='Login__panel'>
          <Grid item xs={12} sm={12} md={12} className='Login__panel--left'>
            <div className='Login__panel--left__content'>
              <div className='Login__panel--left__content__header text-align-center'>
                <h1 className='title'>
                  {app.login_text}
                </h1>
              </div>
              <div className='Login__panel--left__content__form'>
                <ValidatorForm onSubmit={this.login} autoComplete='off'>
                  <TextValidator
                    id='adornment-email'
                    type='text'
                    autoComplete='email'
                    autoFocus
                    name='email'
                    placeholder={literals.email}
                    value={email}
                    className='form__field'
                    onChange={this.handleChange('email')}
                    validators={['required', 'isEmail']}
                    errorMessages={[literals.error.require, literals.error.email]}
                    inputProps={{
                      className: 'form__field__input',
                    }}
                  />
                  <TextValidator
                    id='adornment-password'
                    placeholder={literals.password}
                    type={showPassword ? 'text' : 'password'}
                    autoComplete='current-password'
                    value={password}
                    className='form__field'
                    name='password'
                    onChange={this.handleChange('password')}
                    inputProps={{
                      className: 'form__field__input',
                    }}
                    validators={['required']}
                    errorMessages={[literals.error.require]}
                  />
                  {(loginError !== '') && (
                    <span className='error'>
                      {loginError}
                    </span>
                  )}
                  <div className='Login__panel--left__content__form__description text-align-center'>
                    <span className='title'>
                      {app.poweredBy}
                    </span>
                  </div>
                  <ButtonLogin
                    type='submit'
                  >
                    {literals.actionBtn}
                  </ButtonLogin>
                  <Link to={ROUTE_SIGNUP} className='btn-register'>
                    {literals.register}
                  </Link>
                  <Link to={ROUTE_FORGET_PASSWORD} className='btn-remember-password'>
                    {literals.rememberPassword}
                  </Link>
                </ValidatorForm>
                <div className='Login__panel--left__content__form__social hidden'>
                  <img src={Linkedin} alt='LinkedIn' onClick={this.openLinkedin} />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </LoginWrapper>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login/components/index.jsx